/** 资源加载时序图 */
import React from 'react'
import {Empty, Progress, Tooltip} from 'antd';

const colorMap = {
  xmlhttprequest: '#CAF982',
  fetch: '#FFFF80',
  script: '#FACD91',
  img: '#EC808D',
  css: '#81D3F8',
  iframe: '#C280FF',
  other: '#00FCFD'
}
class ComResource extends React.Component {
  // 表格数据
  updateData(data) {
    return (
      data.map(item => {
        return (<li key={item.id} className='com-resource-content-li'>
          <span className='li-left'>
            <Tooltip overlayStyle={{maxWidth: '500px'}} placement="top" title={item.resourceUrl}>
              {item.resourceUrl}
            </Tooltip>
          </span>
          <span className='li-center'>{item.requestTime}</span>
          <span className='li-right'>{item.resourceType === 'xmlhttprequest' ? 'XHR' : item.resourceType}</span>
          <Progress
            percent={item.requestTime / 100} showInfo={false} strokeLinecap='square' strokeWidth={30}
            strokeColor={colorMap[item.resourceType]} />
        </li>)
      })
    )
  };
  render() {
    const {data} = this.props;
    return (
      <div className='com-resource'>
        <div className={data.length > 3 ? 'com-resource-label margin-r-6' : 'com-resource-label'}>
          <span className='li-left'>URL</span>
          <span className='li-center'>耗时（ms）</span>
          <span className='li-right'>标签</span>
        </div>
        <ul className='com-resource-content scroll-bar'>
          {
            data.length
              ? this.updateData(data)
              : <Empty />
          }
        </ul>
      </div>
    );
  }
}

export default ComResource;
